var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20c0 8.838-7.164 16-16 16S4 28.838 4 20c0-8.833 7.164-16 16-16s16 7.167 16 16zM20.43 9.29c-3.517 0-5.759 1.481-7.52 4.114a.775.775 0 00.175 1.049l2.239 1.697a.774.774 0 001.075-.137c1.152-1.462 1.943-2.31 3.697-2.31 1.318 0 2.948.849 2.948 2.127 0 .966-.797 1.462-2.099 2.192-1.517.85-3.526 1.91-3.526 4.559v.258c0 .427.347.774.774.774h3.613a.774.774 0 00.775-.774v-.086c0-1.837 5.367-1.913 5.367-6.882 0-3.742-3.882-6.58-7.519-6.58zm-.43 16a2.971 2.971 0 00-2.968 2.968A2.971 2.971 0 0020 31.226a2.971 2.971 0 002.968-2.968A2.971 2.971 0 0020 25.29z"
  })));
}
export default SvgQuestionmarkFill;